export default __webpack_public_path__ + "static/media/bigLogo.ade0ab80.svg";